import { render, staticRenderFns } from "./HostsLive.vue?vue&type=template&id=b528067a&scoped=true"
import script from "./HostsLive.vue?vue&type=script&lang=js"
export * from "./HostsLive.vue?vue&type=script&lang=js"
import style0 from "./HostsLive.vue?vue&type=style&index=0&id=b528067a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b528067a",
  null
  
)

export default component.exports